// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAMIdfljCPH9IJaeevZXEFNU8-sVRM2hZU",
  authDomain: "costel-676d9.firebaseapp.com",
  projectId: "costel-676d9",
  storageBucket: "costel-676d9.appspot.com",
  messagingSenderId: "187289225886",
  appId: "1:187289225886:web:32eb7a7b3c39496fe7c98f",
  measurementId: "G-57Z6FDBQ1C"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);